import { Dispatch, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router';

import { Modal } from '../../../UIPackage/ModalModule/components/Modal';
import { ModalHeader } from '../../../UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from '../../../UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from '../../../UIPackage/ModalModule/components/ModalActions';
import { Button } from '../../../UIPackage/MainModule/components/Button';
import { InfoBlock } from '../../../CorePackage/MainModule/components/InfoBlock';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { passportGroupPassportApplyByKno } from '../../../PassportGroupPackage/MainModule/actions/passportGroupActions';
import { PassportGroupPassportTypeEnum } from '../../../PassportGroupPackage/PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';
import { ROUTE_DECISION_ID, ROUTE_KNM_ID, ROUTE_PM_ID } from '../../../CorePackage/MainModule/routes/routes';
import { PassportGroupFileInput } from '../../../PersonalAccountPackage/PassportMassCancellationModule/components/PassportGroupFileInput';
import { IKnmAttachment } from '../../../APIPackage/KnmModule/interfaces/IKnmAttachment';

interface IKnmMassCancelModal {
  visible: boolean;
  onClose: () => void;
  passportId: number | undefined;
}

export const KnmMassCancelModal = ({ visible, onClose, passportId }: IKnmMassCancelModal) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const routeMatch = useRouteMatch();
  const [decisionAttachment, setDecisionAttachment] = useState<IKnmAttachment | undefined>();

  const passportType: PassportGroupPassportTypeEnum | undefined = useMemo(() => {
    switch (routeMatch.path) {
      case ROUTE_KNM_ID:
        return PassportGroupPassportTypeEnum.ERKNM;
      case ROUTE_PM_ID:
        return PassportGroupPassportTypeEnum.PM;
      case ROUTE_DECISION_ID:
        return PassportGroupPassportTypeEnum.DECISION_PASSPORT;
      default:
        return undefined;
    }
  }, [routeMatch]);

  const handleClose = useCallback(() => {
    onClose();
    setDecisionAttachment(undefined);
  }, [onClose, setDecisionAttachment]);

  const handleApply = useCallback(() => {
    if (typeof passportId === 'number' && passportType && decisionAttachment) {
      dispatch(passportGroupPassportApplyByKno(passportId, passportType, decisionAttachment));
      handleClose();
    }
  }, [dispatch, passportType, passportId, decisionAttachment, handleClose]);

  return (
    <Modal visible={visible} onClose={handleClose}>
      <ModalHeader title="Массовая отмена мероприятий" />
      <ModalBody size="content">
        <InfoBlock marginBottom=".7rem">
          Внимание! Мероприятие будет переведено в статус «Отменено». Если Вы уверены, что хотите отменить мероприятие,
          нажмите «Подтвердить». Если Вы не хотите отменять мероприятие, нажмите «Назад»
        </InfoBlock>
        <PassportGroupFileInput
          label="Файл решения об отмене"
          setAttachment={setDecisionAttachment}
          attachment={decisionAttachment}
        />
      </ModalBody>
      <ModalActions>
        <Button
          text="Подтвердить"
          size="medium"
          type="button"
          color="primary"
          onClick={handleApply}
          disabled={!decisionAttachment}
        />
        <Button text="Закрыть" size="medium" type="button" onClick={handleClose} />
      </ModalActions>
    </Modal>
  );
};
